import { Injectable } from '@angular/core';
import { Store as ngxsStore } from '@ngxs/store';
import { UpdateOrder } from 'app/state-management/actions/orders.actions';
import { MasterOrderResponse } from 'app/models/masterOrder.model';
import * as MasterOrderActions from 'app/reducers/master-order.actions';
import { convertMasterOrder } from 'app/services/api-converters';
import { OrganizationsState } from 'app/state-management/states/organizations.states';
import { UntilDestroy } from '@ngneat/until-destroy';
import { HubConnection } from '@microsoft/signalr';
import { Store } from '@ngrx/store';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class EventService {
  constructor(
    private ngxsStore: ngxsStore,
    private store: Store,
  ) {
  }

  public registerEvents(connection: HubConnection) {
    connection.on('NewEvent', (event: string) => {
      console.warn('Unhandled NewEvent:', event);
    });

    connection.on('UpdateEvent', (event: string) => {
      console.warn('Unhandled UpdateEvent:', event);
    });

    connection.on('UpdateOrder', (orderInQueue: string) => {
      this.ngxsStore.dispatch(new UpdateOrder(JSON.parse(orderInQueue)));
    });

    connection.on('UpdateMasterOrder', (data: string) => {
      const masterOrderResponse: MasterOrderResponse = JSON.parse(data) as MasterOrderResponse;
      const connectedOrganizations = this.ngxsStore.selectSnapshot(OrganizationsState.getSelectedOrganizationTree);
      const externalSystems = this.ngxsStore.selectSnapshot(OrganizationsState.getExternalSystems);
      const order = convertMasterOrder(
        masterOrderResponse,
        connectedOrganizations,
        externalSystems
      );
      if (order) {
        this.store.dispatch(MasterOrderActions.updateOrder(order));
      }
    });
  }
}
